
import { appConstants } from "../../action-constants/inapp.constants"
import { 
  LightspeedOAuthSession,
  LightspeedConnection,
  LightspeedConnectionStatus,
  LightspeedInstallation,
  LightspeedApiResponse,
  LightspeedConnectionStatusPayload
} from "../../../shared/types/lightspeed.types";
import { LightspeedError } from "../../../shared/utils/lightspeedErrorHandler";
// import {ReducerParams} from "../../../types"


let userLogged = localStorage.getItem('mamiVXAuth') || "{}";

let user = JSON.parse(userLogged);
const initialState = Object.keys(user).length >= 1 ? { loggedIn: true, user } : { loggedIn: false };

const initialGalleryState :any = {
    // isEndOfCatalogue: false,
    results: [],
    // nextItemsBatch: [],
    // currentPage: 1
  }

export const getImageGalleryReducer = (state:any = initialGalleryState, action: any) => {
    // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
    switch (action.type) {
        case appConstants.GET_IMAGE_GALLERY_PENDING:
            // return {
            //     request_status: appConstants.GET_IMAGE_GALLERY_PENDING,
            //     is_request_processing: true,
            //     request_data: action
            // };
            return Object.assign({}, state, {
                request_status: appConstants.GET_IMAGE_GALLERY_PENDING,
                is_request_processing: true,
                results: [],
                request_data: action,
                galleryData:[]
              })
        case appConstants.GET_IMAGE_GALLERY_SUCCESS:
            
            
            // initialGalleryState.results.concat(action?.response?.results)

            
            // if(action.response.pageNumber===action.response.totalNumberOfPages){
            //     return {
            //         request_status: appConstants.GET_IMAGE_GALLERY_SUCCESS,
            //         is_request_processing: false,
            //         request_data: action,
            //         galleryData :state,
            //         endOfGallery: true
            //     };
            // }
            // return Object.assign({}, state, {
            //     results: state.results.concat(action.response.results),
            //     request_status: appConstants.GET_IMAGE_GALLERY_SUCCESS,
            //     is_request_processing: false,
            //     request_data: action,
            //   })

            return {
                ...state,
                request_status: appConstants.GET_IMAGE_GALLERY_SUCCESS,
                is_request_processing: false,
                request_data: action,
                galleryData :action.results,
                // endOfGallery:false
            };
        case appConstants.GET_IMAGE_GALLERY_NEWBATCH:
            
            
            // initialGalleryState.results.concat(action?.response?.results)
            
            return {
                ...state,
                request_status: appConstants.GET_IMAGE_GALLERY_NEWBATCH,
                is_request_processing: false,
                request_data: action,
                galleryData :[...state.galleryData,...action.results],
            };
        case appConstants.GET_IMAGE_GALLERY_FAILURE:
            return {
                request_status: appConstants.GET_IMAGE_GALLERY_FAILURE,
                is_request_processing: false,
                galleryData :action.results,
                request_data: action
            };
        case appConstants.GET_IMAGE_GALLERY_RESET:
            return {
                request_status: appConstants.GET_IMAGE_GALLERY_RESET,
                is_request_processing: false,
                request_data: {},
            };


        default:
            return { ...state }
    }
}

export const getStoreOrderReducer = (state = initialState, action: any) => {
    // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
    switch (action.type) {
        case appConstants.GET_VENDOR_ORDERS_PENDING:
            return {
                request_status: appConstants.GET_VENDOR_ORDERS_PENDING,
                is_request_processing: true,
                request_data: action
            };
        case appConstants.GET_VENDOR_ORDERS_SUCCESS:
            return {
                request_status: appConstants.GET_VENDOR_ORDERS_SUCCESS,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.GET_VENDOR_ORDERS_FAILURE:
            return {
                request_status: appConstants.GET_VENDOR_ORDERS_FAILURE,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.GET_VENDOR_ORDERS_RESET:
            return {
                request_status: appConstants.GET_VENDOR_ORDERS_RESET,
                is_request_processing: false,
                request_data: {},
            };


        default:
            return { ...state }
    }
}

export const getStoreOrderDetailsReducer = (state = initialState, action: any) => {
    // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
    switch (action.type) {
        case appConstants.GET_VENDOR_ORDER_DETAILS_PENDING:
            return {
                request_status: appConstants.GET_VENDOR_ORDER_DETAILS_PENDING,
                is_request_processing: true,
                request_data: action
            };
        case appConstants.GET_VENDOR_ORDER_DETAILS_SUCCESS:
            return {
                request_status: appConstants.GET_VENDOR_ORDER_DETAILS_SUCCESS,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.GET_VENDOR_ORDER_DETAILS_FAILURE:
            return {
                request_status: appConstants.GET_VENDOR_ORDER_DETAILS_FAILURE,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.GET_VENDOR_ORDER_DETAILS_RESET:
            return {
                request_status: appConstants.GET_VENDOR_ORDER_DETAILS_RESET,
                is_request_processing: false,
                request_data: {},
            };


        default:
            return { ...state }
    }
}
export const linkExternalAccountReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case appConstants.LINK_EXTERNAL_ACCOUNT_PENDING:
            return {
                request_status: appConstants.LINK_EXTERNAL_ACCOUNT_PENDING,
                is_request_processing: true,
                request_data: action
            };
        case appConstants.LINK_EXTERNAL_ACCOUNT_SUCCESS:
            return {
                request_status: appConstants.LINK_EXTERNAL_ACCOUNT_SUCCESS,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.LINK_EXTERNAL_ACCOUNT_FAILURE:
            return {
                request_status: appConstants.LINK_EXTERNAL_ACCOUNT_FAILURE,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.LINK_EXTERNAL_ACCOUNT_RESET:
            return {
                request_status: appConstants.LINK_EXTERNAL_ACCOUNT_RESET,
                is_request_processing: false,
                request_data: {},
            };
        default:
            return { ...state }
    }
}

export const createStorePayoutReducer = (state = initialState, action: any) => {
    // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
    switch (action.type) {
        case appConstants.CREATE_PAYOUT_ACCOUNT_PENDING:
            return {
                request_status: appConstants.CREATE_PAYOUT_ACCOUNT_PENDING,
                is_request_processing: true,
                request_data: action
            };
        case appConstants.CREATE_PAYOUT_ACCOUNT_SUCCESS:
            return {
                request_status: appConstants.CREATE_PAYOUT_ACCOUNT_SUCCESS,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.CREATE_PAYOUT_ACCOUNT_FAILURE:
            return {
                request_status: appConstants.CREATE_PAYOUT_ACCOUNT_FAILURE,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.CREATE_PAYOUT_ACCOUNT_RESET:
            return {
                request_status: appConstants.CREATE_PAYOUT_ACCOUNT_RESET,
                is_request_processing: false,
                request_data: {},
            };


        default:
            return { ...state }
    }
}

export const getStorePayoutAccReducer = (state = initialState, action: any) => {
    // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
    switch (action.type) {
        case appConstants.GET_STORE_PAY_ACCOUNTS_PENDING:
            return {
                request_status: appConstants.GET_STORE_PAY_ACCOUNTS_PENDING,
                is_request_processing: true,
                request_data: action
            };
        case appConstants.GET_STORE_PAY_ACCOUNTS_SUCCESS:
            return {
                request_status: appConstants.GET_STORE_PAY_ACCOUNTS_SUCCESS,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.GET_STORE_PAY_ACCOUNTS_FAILURE:
            return {
                request_status: appConstants.GET_STORE_PAY_ACCOUNTS_FAILURE,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.GET_STORE_PAY_ACCOUNTS_RESET:
            return {
                request_status: appConstants.GET_STORE_PAY_ACCOUNTS_RESET,
                is_request_processing: false,
                request_data: {},
            };


        default:
            return { ...state }
    }
}

export const getStoreDetailsReducer = (state = initialState, action: any) => {
    // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
    switch (action.type) {
        case appConstants.GET_STORE_DETAILS_PENDING:
            return {
                request_status: appConstants.GET_STORE_DETAILS_PENDING,
                is_request_processing: true,
                request_data: action
            };
        case appConstants.GET_STORE_DETAILS_SUCCESS:
            return {
                request_status: appConstants.GET_STORE_DETAILS_SUCCESS,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.GET_STORE_DETAILS_FAILURE:
            return {
                request_status: appConstants.GET_STORE_DETAILS_FAILURE,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.GET_STORE_DETAILS_RESET:
            return {
                request_status: appConstants.GET_STORE_DETAILS_RESET,
                is_request_processing: false,
                request_data: {},
            };


        default:
            return { ...state }
    }
}

export const updateStoreDetailsReducer = (state = initialState, action: any) => {
    // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
    switch (action.type) {
        case appConstants.UPDATE_STORE_DETAILS_PENDING:
            return {
                request_status: appConstants.UPDATE_STORE_DETAILS_PENDING,
                is_request_processing: true,
                request_data: action
            };
        case appConstants.UPDATE_STORE_DETAILS_SUCCESS:
            return {
                request_status: appConstants.UPDATE_STORE_DETAILS_SUCCESS,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.UPDATE_STORE_DETAILS_FAILURE:
            return {
                request_status: appConstants.UPDATE_STORE_DETAILS_FAILURE,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.UPDATE_STORE_DETAILS_RESET:
            return {
                request_status: appConstants.UPDATE_STORE_DETAILS_RESET,
                is_request_processing: false,
                request_data: {},
            };


        default:
            return { ...state }
    }
}

export const getDashbardTopDataReducer = (state = initialState, action: any) => {
    // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
    switch (action.type) {
        case appConstants.GET_DASHBOARD_TOP_DATA_PENDING:
            return {
                request_status: appConstants.GET_DASHBOARD_TOP_DATA_PENDING,
                is_request_processing: true,
                request_data: action
            };
        case appConstants.GET_DASHBOARD_TOP_DATA_SUCCESS:
            return {
                request_status: appConstants.GET_DASHBOARD_TOP_DATA_SUCCESS,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.GET_DASHBOARD_TOP_DATA_FAILURE:
            return {
                request_status: appConstants.GET_DASHBOARD_TOP_DATA_FAILURE,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.GET_DASHBOARD_TOP_DATA_RESET:
            return {
                request_status: appConstants.GET_DASHBOARD_TOP_DATA_RESET,
                is_request_processing: false,
                request_data: {},
            };


        default:
            return { ...state }
    }
}

export const getDashbardMiddleDataReducer = (state = initialState, action: any) => {
    // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
    switch (action.type) {
        case appConstants.GET_DASHBOARD_MIDDLE_DATA_PENDING:
            return {
                request_status: appConstants.GET_DASHBOARD_MIDDLE_DATA_PENDING,
                is_request_processing: true,
                request_data: action
            };
        case appConstants.GET_DASHBOARD_MIDDLE_DATA_SUCCESS:
            return {
                request_status: appConstants.GET_DASHBOARD_MIDDLE_DATA_SUCCESS,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.GET_DASHBOARD_MIDDLE_DATA_FAILURE:
            return {
                request_status: appConstants.GET_DASHBOARD_MIDDLE_DATA_FAILURE,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.GET_DASHBOARD_MIDDLE_DATA_RESET:
            return {
                request_status: appConstants.GET_DASHBOARD_MIDDLE_DATA_RESET,
                is_request_processing: false,
                request_data: {},
            };


        default:
            return { ...state }
    }
}

export const getDashbardBottompDataReducer = (state = initialState, action: any) => {
    // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
    switch (action.type) {
        case appConstants.GET_DASHBOARD_BOTTOM_DATA_PENDING:
            return {
                request_status: appConstants.GET_DASHBOARD_BOTTOM_DATA_PENDING,
                is_request_processing: true,
                request_data: action
            };
        case appConstants.GET_DASHBOARD_BOTTOM_DATA_SUCCESS:
            return {
                request_status: appConstants.GET_DASHBOARD_BOTTOM_DATA_SUCCESS,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.GET_DASHBOARD_BOTTOM_DATA_FAILURE:
            return {
                request_status: appConstants.GET_DASHBOARD_BOTTOM_DATA_FAILURE,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.GET_DASHBOARD_BOTTOM_DATA_RESET:
            return {
                request_status: appConstants.GET_DASHBOARD_BOTTOM_DATA_RESET,
                is_request_processing: false,
                request_data: {},
            };


        default:
            return { ...state }
    }
}

export const createPayoutInfoTokenReducer = (state = initialState, action: any) => {
    // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
    switch (action.type) {
        case appConstants.CREATE_PAYOUT_TOKEN_PENDING:
            return {
                request_status: appConstants.CREATE_PAYOUT_TOKEN_PENDING,
                is_request_processing: true,
                request_data: action
            };
        case appConstants.CREATE_PAYOUT_TOKEN_SUCCESS:
            return {
                request_status: appConstants.CREATE_PAYOUT_TOKEN_SUCCESS,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.CREATE_PAYOUT_TOKEN_FAILURE:
            return {
                request_status: appConstants.CREATE_PAYOUT_TOKEN_FAILURE,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.CREATE_PAYOUT_TOKEN_RESET:
            return {
                request_status: appConstants.CREATE_PAYOUT_TOKEN_RESET,
                is_request_processing: false,
                request_data: {},
            };


        default:
            return { ...state }
    }
}

export const deactivatePayoutAccountReducer = (state = initialState, action: any) => {
    // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
    switch (action.type) {
        case appConstants.DEACTIVATE_PAYOUT_ACCOUNT_PENDING:
            return {
                request_status: appConstants.DEACTIVATE_PAYOUT_ACCOUNT_PENDING,
                is_request_processing: true,
                request_data: action
            };
        case appConstants.DEACTIVATE_PAYOUT_ACCOUNT_SUCCESS:
            return {
                request_status: appConstants.DEACTIVATE_PAYOUT_ACCOUNT_SUCCESS,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.DEACTIVATE_PAYOUT_ACCOUNT_FAILURE:
            return {
                request_status: appConstants.DEACTIVATE_PAYOUT_ACCOUNT_FAILURE,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.DEACTIVATE_PAYOUT_ACCOUNT_RESET:
            return {
                request_status: appConstants.DEACTIVATE_PAYOUT_ACCOUNT_RESET,
                is_request_processing: false,
                request_data: {},
            };


        default:
            return { ...state }
    }
}

export const getPayoutPendingLinkReducer = (state = initialState, action: any) => {
    // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
    switch (action.type) {
        case appConstants.GET_PAYOUT_PENDING_LINK_PENDING:
            return {
                request_status: appConstants.GET_PAYOUT_PENDING_LINK_PENDING,
                is_request_processing: true,
                request_data: action
            };
        case appConstants.GET_PAYOUT_PENDING_LINK_SUCCESS:
            return {
                request_status: appConstants.GET_PAYOUT_PENDING_LINK_SUCCESS,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.GET_PAYOUT_PENDING_LINK_FAILURE:
            return {
                request_status: appConstants.GET_PAYOUT_PENDING_LINK_FAILURE,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.GET_PAYOUT_PENDING_LINK_RESET:
            return {
                request_status: appConstants.GET_PAYOUT_PENDING_LINK_RESET,
                is_request_processing: false,
                request_data: {},
            };


        default:
            return { ...state }
    }
}

export const getStorePaymentsHistoryReducer = (state = initialState, action: any) => {
    // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
    switch (action.type) {
        case appConstants.GET_STORE_PAYMENT_HISTORY_PENDING:
            return {
                request_status: appConstants.GET_STORE_PAYMENT_HISTORY_PENDING,
                is_request_processing: true,
                request_data: action
            };
        case appConstants.GET_STORE_PAYMENT_HISTORY_SUCCESS:
            return {
                request_status: appConstants.GET_STORE_PAYMENT_HISTORY_SUCCESS,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.GET_STORE_PAYMENT_HISTORY_FAILURE:
            return {
                request_status: appConstants.GET_STORE_PAYMENT_HISTORY_FAILURE,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.GET_STORE_PAYMENT_HISTORY_RESET:
            return {
                request_status: appConstants.GET_STORE_PAYMENT_HISTORY_RESET,
                is_request_processing: false,
                request_data: {},
            };


        default:
            return { ...state }
    }
}

export const changeOrderStatusReducer = (state = initialState, action: any) => {
    // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
    switch (action.type) {
        case appConstants.CHANGE_ORDER_STATUS_PENDING:
            return {
                request_status: appConstants.CHANGE_ORDER_STATUS_PENDING,
                is_request_processing: true,
                request_data: action
            };
        case appConstants.CHANGE_ORDER_STATUS_SUCCESS:
            return {
                request_status: appConstants.CHANGE_ORDER_STATUS_SUCCESS,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.CHANGE_ORDER_STATUS_FAILURE:
            return {
                request_status: appConstants.CHANGE_ORDER_STATUS_FAILURE,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.CHANGE_ORDER_STATUS_RESET:
            return {
                request_status: appConstants.CHANGE_ORDER_STATUS_RESET,
                is_request_processing: false,
                request_data: {},
            };


        default:
            return { ...state }
    }
}

export const addNewStoreReducer = (state = initialState, action: any) => {
    // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
    switch (action.type) {
        case appConstants.ADD_A_NEW_STORE_PENDING:
            return {
                request_status: appConstants.ADD_A_NEW_STORE_PENDING,
                is_request_processing: true,
                request_data: action
            };
        case appConstants.ADD_A_NEW_STORE_SUCCESS:
            return {
                request_status: appConstants.ADD_A_NEW_STORE_SUCCESS,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.ADD_A_NEW_STORE_FAILURE:
            return {
                request_status: appConstants.ADD_A_NEW_STORE_FAILURE,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.ADD_A_NEW_STORE_RESET:
            return {
                request_status: appConstants.ADD_A_NEW_STORE_RESET,
                is_request_processing: false,
                request_data: {},
            };


        default:
            return { ...state }
    }
}

export const addAStaffReducer = (state = initialState, action: any) => {
    // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
    switch (action.type) {
        case appConstants.ADD_A_STAFF_PENDING:
            return {
                request_status: appConstants.ADD_A_STAFF_PENDING,
                is_request_processing: true,
                request_data: action
            };
        case appConstants.ADD_A_STAFF_SUCCESS:
            return {
                request_status: appConstants.ADD_A_STAFF_SUCCESS,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.ADD_A_STAFF_FAILURE:
            return {
                request_status: appConstants.ADD_A_STAFF_FAILURE,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.ADD_A_STAFF_RESET:
            return {
                request_status: appConstants.ADD_A_STAFF_RESET,
                is_request_processing: false,
                request_data: {},
            };


        default:
            return { ...state }
    }
}

export const deleteAStaffReducer = (state = initialState, action: any) => {
    // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
    switch (action.type) {
        case appConstants.DELETE_A_STAFF_PENDING:
            return {
                request_status: appConstants.DELETE_A_STAFF_PENDING,
                is_request_processing: true,
                request_data: action
            };
        case appConstants.DELETE_A_STAFF_SUCCESS:
            return {
                request_status: appConstants.DELETE_A_STAFF_SUCCESS,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.DELETE_A_STAFF_FAILURE:
            return {
                request_status: appConstants.DELETE_A_STAFF_FAILURE,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.DELETE_A_STAFF_RESET:
            return {
                request_status: appConstants.DELETE_A_STAFF_RESET,
                is_request_processing: false,
                request_data: {},
            };


        default:
            return { ...state }
    }
}

export const getAllStaffReducer = (state = initialState, action: any) => {
    // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
    switch (action.type) {
        case appConstants.GET_STAFF_LIST_PENDING:
            return {
                request_status: appConstants.GET_STAFF_LIST_PENDING,
                is_request_processing: true,
                request_data: action
            };
        case appConstants.GET_STAFF_LIST_SUCCESS:
            return {
                request_status: appConstants.GET_STAFF_LIST_SUCCESS,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.GET_STAFF_LIST_FAILURE:
            return {
                request_status: appConstants.GET_STAFF_LIST_FAILURE,
                is_request_processing: false,
                request_data: action
            };
        case appConstants.GET_STAFF_LIST_RESET:
            return {
                request_status: appConstants.GET_STAFF_LIST_RESET,
                is_request_processing: false,
                request_data: {},
            };


        default:
            return { ...state }
    }
}

// Lightspeed Integration Reducers

// Define Lightspeed-specific state interfaces
interface LightspeedOAuthState {
    request_status: string;
    is_request_processing: boolean;
    request_data: any;
    oauth_session?: LightspeedOAuthSession;
    error?: LightspeedError;
}

interface LightspeedConnectionState {
  request_status: string;
  is_request_processing: boolean;
  request_data: any;
  connection?: LightspeedConnection | LightspeedConnectionStatusPayload | null;
  error?: LightspeedError;
}

interface LightspeedInstallationState {
    request_status: string;
    is_request_processing: boolean;
    request_data: any;
    installation?: LightspeedInstallation;
    error?: LightspeedError;
}

// Define initial states for Lightspeed reducers
const lightspeedOAuthInitialState: LightspeedOAuthState = {
    request_status: '',
    is_request_processing: false,
    request_data: null
};

const lightspeedConnectionInitialState: LightspeedConnectionState = {
    request_status: '',
    is_request_processing: false,
    request_data: null
};

const lightspeedInstallationInitialState: LightspeedInstallationState = {
    request_status: '',
    is_request_processing: false,
    request_data: null
};

export const lightspeedStartOAuthReducer = (state: LightspeedOAuthState = lightspeedOAuthInitialState, action: any): LightspeedOAuthState => {
    switch (action.type) {
        case appConstants.LIGHTSPEED_START_OAUTH_PENDING:
            return {
                ...state,
                request_status: appConstants.LIGHTSPEED_START_OAUTH_PENDING,
                is_request_processing: true,
                request_data: action,
                error: undefined
            };
        case appConstants.LIGHTSPEED_START_OAUTH_SUCCESS:
            return {
                ...state,
                request_status: appConstants.LIGHTSPEED_START_OAUTH_SUCCESS,
                is_request_processing: false,
                request_data: action,
                oauth_session: action.response?.data,
                error: undefined
            };
        case appConstants.LIGHTSPEED_START_OAUTH_FAILURE:
            return {
                ...state,
                request_status: appConstants.LIGHTSPEED_START_OAUTH_FAILURE,
                is_request_processing: false,
                request_data: action,
                error: action.error
            };
        case appConstants.LIGHTSPEED_START_OAUTH_RESET:
            return {
                ...initialState,
                request_status: appConstants.LIGHTSPEED_START_OAUTH_RESET,
                is_request_processing: false,
                request_data: {},
            };
        default:
            return { ...state }
    }
}

export const lightspeedHandleCallbackReducer = (state: LightspeedConnectionState = lightspeedConnectionInitialState, action: any): LightspeedConnectionState => {
    switch (action.type) {
        case appConstants.LIGHTSPEED_HANDLE_CALLBACK_PENDING:
            return {
                ...state,
                request_status: appConstants.LIGHTSPEED_HANDLE_CALLBACK_PENDING,
                is_request_processing: true,
                request_data: action,
                error: undefined
            };
        case appConstants.LIGHTSPEED_HANDLE_CALLBACK_SUCCESS:
            return {
                ...state,
                request_status: appConstants.LIGHTSPEED_HANDLE_CALLBACK_SUCCESS,
                is_request_processing: false,
                request_data: action,
                connection: action.response?.data,
                error: undefined
            };
        case appConstants.LIGHTSPEED_HANDLE_CALLBACK_FAILURE:
            return {
                ...state,
                request_status: appConstants.LIGHTSPEED_HANDLE_CALLBACK_FAILURE,
                is_request_processing: false,
                request_data: action,
                error: action.error
            };
        case appConstants.LIGHTSPEED_HANDLE_CALLBACK_RESET:
            return {
                ...initialState,
                request_status: appConstants.LIGHTSPEED_HANDLE_CALLBACK_RESET,
                is_request_processing: false,
                request_data: {},
            };
        default:
            return { ...state }
    }
}

export const lightspeedCheckConnectionReducer = (state: LightspeedConnectionState = lightspeedConnectionInitialState, action: any): LightspeedConnectionState => {
    switch (action.type) {
        case appConstants.LIGHTSPEED_CHECK_CONNECTION_PENDING:
            return {
                ...state,
                request_status: appConstants.LIGHTSPEED_CHECK_CONNECTION_PENDING,
                is_request_processing: true,
                request_data: action,
                error: undefined
            };
        case appConstants.LIGHTSPEED_CHECK_CONNECTION_SUCCESS:
            return {
                ...state,
                request_status: appConstants.LIGHTSPEED_CHECK_CONNECTION_SUCCESS,
                is_request_processing: false,
                request_data: action,
                connection: action.response?.data,
                error: undefined
            };
        case appConstants.LIGHTSPEED_CHECK_CONNECTION_FAILURE:
            return {
                ...state,
                request_status: appConstants.LIGHTSPEED_CHECK_CONNECTION_FAILURE,
                is_request_processing: false,
                request_data: action,
                error: action.error
            };
        case appConstants.LIGHTSPEED_CHECK_CONNECTION_RESET:
            return {
                ...initialState,
                request_status: appConstants.LIGHTSPEED_CHECK_CONNECTION_RESET,
                is_request_processing: false,
                request_data: {},
            };
        default:
            return { ...state }
    }
}

export const lightspeedDisconnectReducer = (state: LightspeedConnectionState = lightspeedConnectionInitialState, action: any): LightspeedConnectionState => {
    switch (action.type) {
        case appConstants.LIGHTSPEED_DISCONNECT_PENDING:
            return {
                ...state,
                request_status: appConstants.LIGHTSPEED_DISCONNECT_PENDING,
                is_request_processing: true,
                request_data: action,
                error: undefined
            };
        case appConstants.LIGHTSPEED_DISCONNECT_SUCCESS:
            return {
                ...state,
                request_status: appConstants.LIGHTSPEED_DISCONNECT_SUCCESS,
                is_request_processing: false,
                request_data: action,
                connection: undefined, // Clear connection on successful disconnect
                error: undefined
            };
        case appConstants.LIGHTSPEED_DISCONNECT_FAILURE:
            return {
                ...state,
                request_status: appConstants.LIGHTSPEED_DISCONNECT_FAILURE,
                is_request_processing: false,
                request_data: action,
                error: action.error
            };
        case appConstants.LIGHTSPEED_DISCONNECT_RESET:
            return {
                ...initialState,
                request_status: appConstants.LIGHTSPEED_DISCONNECT_RESET,
                is_request_processing: false,
                request_data: {},
            };
        default:
            return { ...state }
    }
}

export const lightspeedCheckInstallationReducer = (state: LightspeedInstallationState = lightspeedInstallationInitialState, action: any): LightspeedInstallationState => {
    switch (action.type) {
        case appConstants.LIGHTSPEED_CHECK_INSTALLATION_PENDING:
            return {
                ...state,
                request_status: appConstants.LIGHTSPEED_CHECK_INSTALLATION_PENDING,
                is_request_processing: true,
                request_data: action,
                error: undefined
            };
        case appConstants.LIGHTSPEED_CHECK_INSTALLATION_SUCCESS:
            return {
                ...state,
                request_status: appConstants.LIGHTSPEED_CHECK_INSTALLATION_SUCCESS,
                is_request_processing: false,
                request_data: action,
                installation: action.response?.data,
                error: undefined
            };
        case appConstants.LIGHTSPEED_CHECK_INSTALLATION_FAILURE:
            return {
                ...state,
                request_status: appConstants.LIGHTSPEED_CHECK_INSTALLATION_FAILURE,
                is_request_processing: false,
                request_data: action,
                error: action.error
            };
        case appConstants.LIGHTSPEED_CHECK_INSTALLATION_RESET:
            return {
                ...initialState,
                request_status: appConstants.LIGHTSPEED_CHECK_INSTALLATION_RESET,
                is_request_processing: false,
                request_data: {},
            };
        default:
            return { ...state }
    }
}